import { BillingProductNameEnum } from '../../enum/billing/billing-product.enum';

interface Validation {
  pattern: RegExp;
  message: string;
}
export const EXTERNAL_ID_MAP_VALIDATION: { [key: string]: Validation } = {
  [BillingProductNameEnum.Synergy]: {
    pattern: /^[0-9]*$/,
    message:
      'module-configuration.synergy.alerts.external-id-map-invalid-pattern',
  },
};
